import { FC, useState, useEffect } from "react";
import { Grid } from "@mui/material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ApiStatus } from "../../types/api/status";
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop";
import { TeacherWeb } from "../../types/slices/teachersWebType";
import { useTeacherWebStore } from "../../hooks/useTeacherWebStore";
import { CreateEditTeacherWebModal } from "./components/CreateEditTeacherWebModal";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";

const columns = [
  { type: "options", field: "options", label: "Opciones", align: "center" },
  { type: "text", field: "name", label: "DOCENTE" },
  { type: "text", field: "specialty", label: "ESPECIALIDAD", align: "center" },
  {
    type: "text",
    field: "linkedin_url",
    label: "LINKEDIN",
    align: "center",
    format: (row) =>
      row.linkedin_url ? (
        <a
          href={row.linkedin_url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#0a66c2", fontWeight: 500 }}
        >
          Ver perfil
        </a>
      ) : (
        "-"
      ),
  },
  {
    type: "image",
    field: "image",
    label: "IMAGEN",
    align: "center",
    format: (row) =>
      row.image ? <img src={row.image} alt="logo" width="50px" style={{ borderRadius: "20px" }} /> : "",
  },
  {
    type: "text",
    field: "status",
    label: "ESTADO",
    align: "center",
    format: (row) => (row.status ? "Activo" : "Inactivo"),
  },
];

const TeachersWeb: FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [modalDeleteConfirm, setModalDeleteConfirm] = useState<boolean>(false);
  const [rowSelected, setRowSelected] = useState<TeacherWeb>({} as TeacherWeb);

  const {
    teachersWeb,
    status,
    openModal,
    getTeachersWeb,
    setOpenModal,
    setEditTeacherWeb,
    changeIsEdit,
    deleteTeacherWebStore,
    getTeachersWebSearch,
    setSelectedTeacherWeb
  } = useTeacherWebStore();

  useEffect(() => {
    setLoading(true);
    getTeachersWeb().then(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onAdd = () => {
    changeIsEdit(false);
    setOpenModal(true);
  };

  const onEdit = (rowSelected) => {
    changeIsEdit(true);
    setEditTeacherWeb(rowSelected);
    setOpenModal(true);
  };

  const onDelete = (rowSelected) => {
    setRowSelected(rowSelected);
    setModalDeleteConfirm(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const onSearch = (value) => {
    if (value.length >= 1) {
      getTeachersWebSearch(value);
    }
    if (value.length === 0) {
      getTeachersWeb();
    }
  };

  const onDeleteConfirm = async () => {
    const response = await deleteTeacherWebStore(rowSelected?.id || 0);
    if (response === true) {
      setSelectedTeacherWeb({} as TeacherWeb);
      setModalDeleteConfirm(false);
      getTeachersWeb();
    }
  };

  return (
    <>
      {status === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
      <Grid item xs={12}>
        <CustomTable
          title={"Docentes"}
          columns={columns}
          loading={loading}
          rows={teachersWeb || []}
          onRowClick={() => {}}
          hasOptions
          onAddFn={onAdd}
          onDelete={onDelete}
          onEdit={onEdit}
          onSearch={onSearch}
          rowsPerPage={rowsPerPage}
          page={page}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Grid>
      {modalDeleteConfirm && (
        <ModalConfirm
          open={modalDeleteConfirm}
          closeModal={() => {
            setModalDeleteConfirm(false);
          }}
          onCancel={() => {
            setModalDeleteConfirm(false);
          }}
          onConfirm={onDeleteConfirm}
          status={status}
        />
      )}
      {openModal && <CreateEditTeacherWebModal />}
    </>
  );
};

export default TeachersWeb;
